import { render } from "./EditCompany.vue?vue&type=template&id=e675ea82"
import script from "./EditCompany.vue?vue&type=script&lang=js"
export * from "./EditCompany.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akiowatanabe/work_space/secure_link/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__